export default "__VITE_ASSET__CYnhF6mA__"